<new-flowbanner [showPromo]="true"></new-flowbanner>

<section class="payment-status" data-testid="payment-processing-page">
  <div class="payment-status__layout">
    <div class="payment-status__left">
      <div class="payment-status__text">
        <h1 class="payment-status__title">Estamos procesando tu pago</h1>
        <p class="payment-status__subtitle">
          En este momento estamos validando la información del pago.<br />
          Te enviaremos un correo con la confirmación y los detalles de tu seguro.
        </p>
      </div>
      <div class="payment-status__hero">
        <img
          src="./assets/img/ProcesandoPago.png"
          width="500" height="500" loading="lazy"
          alt="Ilustración de procesamiento de pago." />
      </div>
    </div>

    <div class="payment-status__right" data-testid="pending-state">
      <section class="payment-info" data-testid="payment-info-card">
        <h2 class="payment-section-title">Información de pago</h2>

        <dl class="payment-info__list">
          <dt>Estado</dt>
          <dd>Pendiente</dd>

          <dt>Valor</dt>
          <dd>$ {{ valorAPagar() | number: '1.0-0' }}</dd>

          <dt>Código respuesta</dt>
          <dd>PT</dd>

          <dt>Referencia de pago</dt>
          <dd>{{ paymentReference() }}</dd>

          <dt>Forma de pago</dt>
          <dd>{{ tipoPago() || 'N/A' }}</dd>
        </dl>
      </section>

      <section class="purchase-summary" data-testid="purchase-summary-card">
        <h2 class="payment-section-title">Resumen de compra</h2>

        <article class="plan-card">
          <header class="plan-card__header">
            <div class="plan-card__header-text">
              <h3 class="plan-card__title">{{ planTitle() }}</h3>
              <p class="plan-card__address">
                <strong>Dirección:</strong> {{ propertyAddress() }}
              </p>
            </div>
            <img class="plan-card__logo"
                 src="./assets/img/Capa_1-2-Logo.svg"
                 width="72" height="26"
                 alt="Logo SURA" />
          </header>

          <div class="plan-card__body">
            <div class="plan-card__section plan-card__owner">
              <h4 class="plan-card__section-title">Dueño:</h4>
              <div class="plan-card__owner-row">
                <div class="plan-card__owner-info">
                  <p class="plan-card__owner-name">{{ ownerName() }}</p>
                  <p *ngIf="propertyCity()" class="plan-card__owner-city">{{ propertyCity() }}</p>
                </div>
                <p class="plan-card__owner-doc">
                  {{ ownerDocumentType() }} {{ ownerDocumentNumber() || 'No disponible' }}
                </p>
              </div>
            </div>

            <hr class="plan-card__divider" *ngIf="coverages().length" />

            <div *ngIf="coverages().length" class="plan-card__section">
              <h4 class="plan-card__section-title">Coberturas:</h4>
              <ul class="plan-card__coverages">
                <li *ngFor="let cov of coverages()">
                  <img class="plan-card__check"
                       src="./assets/img/svg/check.svg"
                       width="20" height="20"
                       alt="" aria-hidden="true" />
                  <span>{{ cov }}</span>
                </li>
              </ul>
            </div>

            <hr class="plan-card__divider" *ngIf="effectiveDate()" />

            <div *ngIf="effectiveDate()" class="plan-card__section plan-card__date">
              <p class="plan-card__date-label">Fecha de inicio del contrato de arrendamiento</p>
              <p class="plan-card__date-value">{{ effectiveDate() }}</p>
            </div>

            <hr class="plan-card__divider" />

            <div class="plan-card__section plan-card__total">
              <p class="plan-card__total-label">Pago Total</p>
              <p class="plan-card__total-value">${{ valorAPagar() | number: '1.0-0' }}</p>
            </div>
          </div>
        </article>

        <div class="purchase-summary__cta">
          <button type="button"
                  class="btn-understood"
                  data-testid="understood-button"
                  (click)="entendido()">
            Entendido
          </button>
        </div>
      </section>
    </div>
  </div>
</section>

<app-footer-app></app-footer-app>
